/**
 * Copied from ClinicalHUD2 2026-10-12 (D-CM7-01). Do not edit ClinicalHUD2 to change ChartMind-7.
 */
import { isLikelyIosDevice } from 'utils/isLikelyIosDevice';
import { isChartMind7ProductPath } from 'features/clinicalHud/marketing/clinicalHudMarketingRouting';

/**
 * localStorage CLINICALCM7_IOS=1 previews the iPhone/iPad HUD2 chrome on any device.
 */
export const CLINICALCM7_IOS_PREVIEW_KEY = 'CLINICALCM7_IOS';

export function isChartMind7IosPreviewEnabled() {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage?.getItem(CLINICALCM7_IOS_PREVIEW_KEY) === '1';
  } catch {
    return false;
  }
}

export function isChartMind7IosLayoutEnabled() {
  return isChartMind7IosPreviewEnabled() || isLikelyIosDevice();
}

export function shouldHideGlobalTopBarForChartMind7(pathname) {
  return (
    isChartMind7IosLayoutEnabled() && isChartMind7ProductPath(pathname)
  );
}

export function useChartMind7IosLayout() {
  return isChartMind7IosLayoutEnabled();
}

/**
 * Voice enrollment uses getUserMedia + Web Audio, which on iPhone/iPad steals
 * the mic from webkitSpeechRecognition and often fails after the tap gesture.
 * Skip it whenever the iOS HUD is showing, the device is iOS, or the pointer is coarse.
 */
export function shouldSkipHud2VoiceEnrollment() {
  if (isChartMind7IosLayoutEnabled()) return true;
  if (isLikelyIosDevice()) return true;
  if (typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)')?.matches) {
    return true;
  }
  return false;
}
